export const requestError = (error, msg) => {
  return error?.response?.data?.message || msg || "Some thing went wrong!";
};
